import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import MobileNavbar from './MobileNavbar';
import DesktopSidebar from './DesktopSidebar';
import { authClient } from "../lib/auth-client";

const MainLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { data: session } = authClient.useSession();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: 0, minHeight: '100vh' }}>
      <Navbar session={session} />

      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
          minHeight: 0,
          minWidth: 0,
          width: '100%',
          overflowX: 'hidden',
          bgcolor: 'background.default',
        }}
      >
        {isMobile ? null : <DesktopSidebar session={session} />}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            pb: isMobile ? '110px' : 0,
            bgcolor: 'background.default',
          }}
        >
          <Outlet />
        </Box>
      </Box>

      {isMobile ? <MobileNavbar session={session} /> : null}
    </Box>
  );
};

export default MainLayout;
